module.exports = __webpack_public_path__ + "static/media/64.961978f7.jpg";